import React from 'react';
import './TodosLoading.css';

function TodosLoading(props) {
    return (
        <div className='stroke'><p>Loading...</p></div>
    );
}

export { TodosLoading };